var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-form',_vm._b({},'base-form',Object.assign({}, _vm.settings),false),[_c('base-password',{staticClass:"gocc__authentication__form__field",attrs:{"input":_vm.input,"settings":{
            label: { class: 'field__label--hide', text: _vm.$t('global.password') },
            input: {
                name: 'password',
                class: 'gocc__authentication__form__field__input',
                placeholder: _vm.$t('global.password'),
                browserAutocomplete: 'new-password',
                fileValidation: 'password',
                errors: [{
                    type: 'validateStrenghtPassword', warning: _vm.$t('error.password')
                }],
                isMissing: _vm.errors.missing.password,
                noListener: true
            }
        }}}),_c('base-password',{staticClass:"gocc__authentication__form__field",attrs:{"input":_vm.input,"settings":{
            label: { class: 'field__label--hide', text: _vm.$t('global.confirmPassword') },
            input: {
                name: 'confirmPassword',
                class: 'gocc__authentication__form__field__input',
                placeholder: _vm.$t('global.confirmPassword'),
                browserAutocomplete: 'confirm-password',
                fileValidation: 'confirmPassword',
                errors: [{
                    type: 'sameAsPassword', warning: _vm.$t('error.confirmPassword')
                }],
                validationParameter: _vm.payload.password,
                isMissing: _vm.errors.missing.confirmPassword,
                noListener: true
            }
        }}}),_c('div',{staticClass:"gocc__authentication__form__field--margin"},[_c('submission-handler',[_c(_vm.button,{tag:"component",staticClass:"gocc__authentication__form__button background--green color--white",attrs:{"type":"submit"},domProps:{"innerHTML":_vm._s(_vm.$t('global.confirm'))}})],1)],1),_c('router-link',{staticClass:"gocc__authentication__form__anchor gocc__authentication__form__back display--block color--green capitalize",attrs:{"to":"/authentication/login","activeClass":"active"}},[_vm._v(" "+_vm._s(_vm.$t('authentication.back'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }